import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, NativeSyntheticEvent, TextInputKeyPressEventData } from "react-native";

import { CustomCircleCheckBox } from "../base/CustomCheckBox";
import { CustomConfirmBtn } from "../base/CustomConfirmBtn";
import { InputTextUnderLine } from "../base/CustomInputText";
import { FONT } from "../../value/staticValues";

// Img
import { ReactComponent as IcoLoginAdmin } from "../../img/ico-login-admin.svg";
//import { ReactComponent as IllustLoginBgUser } from "../../img/illust-login-bg-rep-cloud.svg";
import { ReactComponent as IllustLoginBgUser } from "../../img/illust-login-bg-admin.svg";



import LoginBox from "../base/tamplate/LoginBox";
import AlertContent from "../base/tamplate/AlartContent";
import { PAGE_URL } from "../../value/Url";

interface LoginProps {
    loginBtnClick: Function;
    loginStatus: boolean;
    email: string;
    setEmail: Function;
    setPassword: Function;
    setIdSaveCheck: Function;
    idSaveCheck: boolean;
    alartText: string;
    navigate: Function;
}

export default function Login(props:LoginProps) {
    const { t } = useTranslation();

    const emailInputRef = useRef<HTMLInputElement>(null);
    const pwdInputRef = useRef<HTMLInputElement>(null);

    return (
        <LoginBox>
            <View style={{
                flexDirection:"row", alignItems: "center", justifyContent: "center",
                marginTop: 60, marginBottom: 60,
            }}>
                <View style={{
                    width: 300
                }}>
                    <View style={{
                        flexDirection: "row", alignItems: "center",
                    }}>
                        <IcoLoginAdmin/>
                        <Text style={{
                            marginLeft: 8,
                            fontFamily: FONT.MEDIUM,
                            fontSize: 24,
                            lineHeight: 36,
                            letterSpacing: -0.16,
                            color: "#333"
                        }}>
                            {t("LOGIN_TEXT")}
                        </Text>
                    </View>
                    <Text style={{
                        marginTop: 27,
                        fontFamily: FONT.REGULAR,
                        fontSize: 14,
                        color: "#3a3b3f"
                    }}>
                        {t("LOGIN_REQUIRE_TEXT")}
                    </Text>
                    <View style={{
                        marginTop: 56
                    }}>
                        <IllustLoginBgUser/>
                    </View>
                </View>
                <View style={{
                    width: 360,
                    marginLeft: 60
                }}>
                    <InputTextUnderLine
                        inputref={emailInputRef}
                        text={t("EMAIL_TEXT")}
                        value={props.email}
                        inputprops={{
                            placeholder: t("EMAIL_TEXT"),
                            onChangeText: (Text:string) => props.setEmail(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    pwdInputRef.current?.focus();       
                                }
                            }
                        }}
                    />

                    <InputTextUnderLine
                        inputref={pwdInputRef}
                        text={t("PASSWORD_TEXT")}
                        inputprops={{
                            secureTextEntry: true,
                            placeholder: t("PASSWORD_TEXT"),
                            onChangeText: (Text:string) => props.setPassword(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    props.loginBtnClick()
                                }
                            }
                        }}
                    />

                    <View style={{
                        marginTop: 33
                    }}>
                        <AlertContent
                            size={33}
                            text={props.alartText}
                        />
                    </View>
                    
                    <View style={{marginTop: 10}}>
                        <CustomCircleCheckBox
                            id={"SaveIdCheck"}
                            label={t("LOGIN_REMEMBER_TEXT")}
                            checked={props.idSaveCheck}
                            setCheckBoxStatus={(e:any) => {
                                props.setIdSaveCheck(e);
                            }}
                        />
                    </View>

                    <View style={{marginTop: 16}}>
                        <CustomConfirmBtn
                            size={{width: 360, height: 52}}
                            fontsize={14}
                            disabled={props.loginStatus}
                            text={props.loginStatus ? t("LOGIN_ING_TEXT") : t("LOGIN_TEXT")}
                            onPress={() => {
                                if(!props.loginStatus) {
                                    props.loginBtnClick()
                                }
                            }}
                        />
                    </View>
                    <View style={{
                        flexDirection: "row", alignItems: "center", justifyContent: "center",
                        marginTop: 16,
                    }}>
                        <Text style={{
                            fontFamily: FONT.REGULAR,
                            fontSize: 12,
                            color: "#5c5c5c"
                        }}>
                            {t("FORGET_PASSWORD_ASK_MESSAGE")}
                        </Text>
                        <Text 
                            style={{
                                marginLeft: 10,
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#0853fb"
                            }}
                            onPress={() => {
                                props.navigate(`${PAGE_URL.RESETPWD}`);
                            }}
                        >
                            {t("PASSWORD_FIND_TEXT")}
                        </Text>
                    </View>
                </View>

            </View>
            
        </LoginBox>
    )
}